import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, take, takeUntil } from 'rxjs';

export const cancelOnNavigateInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  const navigatedAway$ = router.events.pipe(
    filter((event) => event instanceof NavigationStart),
    take(1)
  );

  return next(req).pipe(takeUntil(navigatedAway$));
};
